<style scoped lang="less">
  .statistics {
    margin-bottom: 10px;

    label {
      font-weight: 600;
    }
  }
</style>
<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>资金管理</Breadcrumb-item>
        <Breadcrumb-item>用户账单</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Row class-name="statistics">
        <i-col :md="4">
          总实付金额: <label>{{statistics.totalPayment}}</label>
        </i-col>
        <i-col :md="3">
          总金额: <label>{{statistics.totalAmount}}</label>
        </i-col>
        <i-col :md="3">
          总折扣: <label>{{statistics.totalDiscount}}</label>
        </i-col>
      </Row>
      <Form :label-width="50" :show-message="false" lable-position="left">
        <Row :gutter="32">
          <Col :span="6">
          <Form-item label="学生ID" prop="uid">
            <Input name="uid" v-model="queryParam.uid"></Input>
            <input type="text" style="display: none">
          </Form-item>
          </Col>
          <Col :span="2">
          <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                  @click="search">搜索
          </Button>
          </Col>
        </Row>
      </Form>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/fundUserBill/list"
          :params="queryParam" :onLoading="onLoading" operator=""></List>
  </div>

</template>
<script>
  export default {
    data () {
      let $constant = this.$constant
      let $moment = this.$moment
      let $numeral = this.$numeral
      return {
        searchLoading: false,
        reload: 0,
        statistics: {
          totalPayment: 0,
          totalAmount: 0,
          totalDiscount: 0
        },
        queryParam: {
          uid: ''
        },
        adminUser: [],
        title: [
          {
            title: '学生ID、姓名',
            // width: 170,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('div', [
                h('span', row.uid),
                h('br'),
                h('span', row.userNickname || '')
              ])
            }
          },
          {
            title: '订单号',
            // width: 225,
            align: 'center',
            key: 'outOrderId'
          },
          {
            title: '课时次数',
            // width: 100,
            align: 'center',
            key: 'num'
          },
          {
            title: '课程原价',
            // width: 95,
            align: 'center',
            render: (h, params) => {
              return h('span', $numeral(params.row.fundPackageAmount).format('0,0.00'))
            }
          },
          {
            title: '优惠金额',
            // width: 95,
            key: 'discount',
            align: 'center',
            render: (h, params) => {
              return h('span', $numeral(params.row.fundPackageDiscount).format('0,0.00'))
            }
          },
          {
            title: '实付金额',
            // width: 95,
            key: 'payAmount',
            align: 'center',
            render: (h, params) => {
              return h('span', $numeral(params.row.fundPackagePayAmount).format('0,0.00'))
            }
          },
          {
            title: '支付类型',
            align: 'center',
            // width: 100,
            render: (h, params) => {
              let type = params.row.type
              let typeEnum = $constant.getEnum($constant.fundUserBillType, type)
              return h('span', typeEnum && typeEnum.text)
            }
          },
          {
            title: '描述',
            // width: 170,
            align: 'center',
            key: 'description'
          },
          {
            title: '创建时间',
            width: 170,
            align: 'center',
            render: (h, params) => {
              let createTime = params.row.createTime
              return h('span', createTime && $moment(createTime, 'X').format('YYYY-MM-DD HH:mm:ss'))
            }
          }
        ]
      }
    },
    mounted: function () {
      let self = this
      let queryParam = this.queryParam
      queryParam.uid = this.$route.query.uid
      this.$http.post('/adminUser/listByCondition', {status: 1}).then(function (res) {
        self.adminUser = res.data
      })
    },
    created: function () {
      this.$http.get('/fundUserBill/statistics', {params: {state: 1}}).then(res => {
        this.statistics = res.data
      })
    },
    methods: {
      search () {
        this.reload = new Date().getTime()
      },
      onLoading (loading) {
        this.searchLoading = loading
      }
    }
  }
</script>



// WEBPACK FOOTER //
// FundUserBillList.vue?858d5c72